module.exports = __webpack_public_path__ + "img/service_code.d2d6275a.png";